/* Zeldora theme scripts: sticky header offset, mobile menu, dropdowns,
   product photo galleries, product quantity, and the slide-out cart. */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- Sticky header height (marquee + navigation) ---------- */
  function setHeaderHeights() {
    var banner = $('.shipping-banner');
    var headerSection = $('#shopify-section-header');
    var docStyle = document.documentElement.style;
    docStyle.setProperty('--announcement-height', (banner ? banner.offsetHeight : 0) + 'px');
    docStyle.setProperty('--sticky-header-height', (headerSection ? headerSection.offsetHeight : 0) + 'px');
  }

  /* ---------- Mobile menu ---------- */
  function initMobileMenu() {
    var toggle = $('.mobile-menu-toggle');
    var nav = $('#MainNavigation');
    if (!toggle || !nav) return;

    function close() {
      nav.classList.remove('mobile-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Open menu');
    }

    toggle.addEventListener('click', function () {
      var open = !nav.classList.contains('mobile-open');
      nav.classList.toggle('mobile-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });

    nav.addEventListener('click', function (e) {
      if (e.target.closest('a')) close();
    });

    document.addEventListener('click', function (e) {
      if (!nav.classList.contains('mobile-open')) return;
      if (!e.target.closest('#MainNavigation') && !e.target.closest('.mobile-menu-toggle')) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('mobile-open')) { close(); toggle.focus(); }
    });
  }

  /* ---------- Details dropdowns: only one open at a time ---------- */
  function setDetailsOpen(btn, open) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    btn.setAttribute('aria-expanded', String(open));
    panel.hidden = !open;
    var sign = btn.querySelector('span');
    if (sign) sign.textContent = open ? '−' : '+';
  }

  function initDetailsToggles() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-details-toggle]');
      if (!btn) return;
      var willOpen = btn.getAttribute('aria-expanded') !== 'true';
      if (willOpen) {
        $$('[data-details-toggle][aria-expanded="true"]').forEach(function (other) {
          if (other !== btn) setDetailsOpen(other, false);
        });
      }
      setDetailsOpen(btn, willOpen);
    });
  }

  /* FAQ and feature dropdowns use <details name="…">. Modern browsers keep one
     open per group already; this covers browsers that don't. */
  function initExclusiveDetails() {
    $$('details[name]').forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        $$('details[name]').forEach(function (other) {
          if (other !== d && other.getAttribute('name') === d.getAttribute('name') && other.open) other.open = false;
        });
      });
    });
  }

  /* ---------- Product photo galleries ---------- */
  function initGallery(thumbs) {
    if (thumbs.dataset.ready) return;
    thumbs.dataset.ready = 'true';

    var images;
    try { images = JSON.parse(thumbs.getAttribute('data-images') || '[]'); } catch (err) { images = []; }
    var id = thumbs.getAttribute('data-gallery');
    var main = document.getElementById(id + '-main');
    if (!main || !images.length) { thumbs.hidden = true; return; }

    if (id === 'product-page') thumbs.classList.add('product-page-thumbs');
    var alt = main.getAttribute('alt') || '';
    var current = 0;

    var buttons = images.map(function (src, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Show photo ' + (i + 1) + ' of ' + images.length);
      b.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
      var img = document.createElement('img');
      img.src = src.replace(/width=\d+/, 'width=160');
      img.alt = '';
      img.loading = 'lazy';
      b.appendChild(img);
      b.addEventListener('click', function () { show(i); });
      thumbs.appendChild(b);
      return b;
    });

    function keepInView(btn) {
      // The strip is position:relative, so offsetLeft is measured from its own edge.
      var left = btn.offsetLeft;
      var right = left + btn.offsetWidth;
      if (left < thumbs.scrollLeft) {
        thumbs.scrollLeft = left;
      } else if (right > thumbs.scrollLeft + thumbs.clientWidth) {
        thumbs.scrollLeft = right - thumbs.clientWidth;
      }
    }

    function show(i) {
      current = (i + images.length) % images.length;
      main.src = images[current];
      main.removeAttribute('srcset');
      main.alt = alt;
      buttons.forEach(function (b, n) { b.setAttribute('aria-pressed', n === current ? 'true' : 'false'); });
      keepInView(buttons[current]);
    }

    if (images.length > 1) {
      var frame = main.closest('.product-image-frame');
      [['prev', -1, '‹', 'Previous photo'], ['next', 1, '›', 'Next photo']].forEach(function (a) {
        var arrow = document.createElement('button');
        arrow.type = 'button';
        arrow.className = 'gallery-arrow gallery-' + a[0];
        arrow.setAttribute('aria-label', a[3]);
        arrow.innerHTML = '<span aria-hidden="true">' + a[2] + '</span>';
        arrow.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          show(current + a[1]);
        });
        frame.appendChild(arrow);
      });
    } else {
      thumbs.classList.add('single-photo');
    }

    thumbs.classList.add('gallery-browsed');
  }

  function initGalleries() { $$('.thumbs[data-gallery]').forEach(initGallery); }

  /* ---------- Product page quantity −/+ ---------- */
  function initProductQuantity() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-product-step]');
      if (!btn) return;
      var input = btn.parentElement.querySelector('input[type="number"]');
      if (!input) return;
      var next = (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute('data-product-step'), 10);
      input.value = Math.max(1, next);
    });
  }

  /* ---------- Contact form result ---------- */
  function initContactResult() {
    var result = $('[data-contact-result]');
    if (!result) return;
    result.scrollIntoView({ block: 'start' });
    result.focus({ preventScroll: true });
  }

  /* ---------- Cart ---------- */
  var drawer, lastFocus, busy = false;
  var isCartPage = !!$('.cart-page');

  /* Turn any Shopify cart response into data, or into a friendly error. */
  var ADD_FAIL = 'Sorry, we couldn\u2019t add this to your cart. Please try again.';
  var UPDATE_FAIL = 'Sorry, we couldn\u2019t update your cart. Please try again.';

  function friendlyError(message) {
    var e = new Error(message);
    e.friendly = true;
    return e;
  }

  function cleanMessage(text) {
    if (!text || typeof text !== 'string') return '';
    var plain = text.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
    // Only show Shopify's own sentence if it reads like normal text, not code.
    if (plain.length < 4 || plain.length > 180) return '';
    if (/[{}<>\[\]]|undefined|null|exception|error\b|token|json|\b\d{3}\b/i.test(plain)) return '';
    return plain;
  }

  function readCartResponse(r, fallback) {
    return r.text().then(function (body) {
      var data = null;
      try { data = JSON.parse(body); } catch (e) { data = null; }
      if (r.ok && data) return data;
      if (r.status === 429) throw friendlyError('Lots of people are shopping right now. Please try again in a moment.');
      var msg = data && (cleanMessage(data.description) || cleanMessage(data.message));
      throw friendlyError(msg || fallback);
    });
  }

  function messageFor(err, fallback) {
    if (err && err.friendly) return err.message;
    if (typeof navigator !== 'undefined' && navigator.onLine === false) {
      return 'You seem to be offline. Please check your connection and try again.';
    }
    return fallback;
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
    $$('[data-open-cart]').forEach(function (el) {
      el.setAttribute('aria-label', 'Cart, ' + count + ' item' + (count === 1 ? '' : 's'));
    });
  }

  function fetchSection(sectionId) {
    var url = window.location.pathname + '?section_id=' + encodeURIComponent(sectionId);
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('Section ' + r.status); return r.text(); })
      .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
  }

  /* Re-render the drawer (and the full cart page when on it) from Shopify. */
  function refreshCart() {
    var jobs = [];

    if (drawer) {
      jobs.push(fetchSection('cart-drawer').then(function (doc) {
        var freshContent = $('.cart-drawer-content', doc);
        var freshTitle = $('#CartDrawerTitle', doc);
        if (freshContent) $('.cart-drawer-content', drawer).innerHTML = freshContent.innerHTML;
        if (freshTitle) $('#CartDrawerTitle', drawer).textContent = freshTitle.textContent;
      }));
    }

    var pageSection = isCartPage && $('.cart-page') && $('.cart-page').closest('[id^="shopify-section-"]');
    if (pageSection) {
      var pageId = pageSection.id.replace('shopify-section-', '');
      jobs.push(fetchSection(pageId).then(function (doc) {
        var fresh = doc.getElementById(pageSection.id) || doc.body;
        pageSection.innerHTML = (fresh.id === pageSection.id ? fresh.innerHTML : fresh.innerHTML);
      }));
    }

    jobs.push(fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCount(cart.item_count); })
      .catch(function () {}));

    // A failed refresh never blocks the customer; the next page load corrects it.
    return Promise.all(jobs).catch(function () {});
  }

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    document.documentElement.classList.add('cart-open');
    var panel = $('.cart-drawer', drawer);
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      panel.focus({ preventScroll: true });
    });
  }

  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('cart-open');
    setTimeout(function () { drawer.hidden = true; }, 250);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function showCartError(message, ctx) {
    var box = $('.cart-error', ctx || document);
    if (!box) { window.alert(message); return; }
    box.textContent = message;
    box.hidden = false;
  }

  function changeLine(key, quantity, ctx) {
    if (busy) return Promise.resolve();
    busy = true;
    var scope = ctx || document;
    $$('.cart-item', scope).forEach(function (el) { el.classList.add('is-updating'); });

    return fetch(root + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return readCartResponse(r, UPDATE_FAIL); })
      .then(refreshCart)
      .catch(function (err) {
        $$('.cart-item', scope).forEach(function (el) { el.classList.remove('is-updating'); });
        showCartError(messageFor(err, UPDATE_FAIL), scope);
        return refreshCart();
      })
      .then(function () { busy = false; }, function () { busy = false; });
  }

  function addToCart(form) {
    var button = form.querySelector('[type="submit"]');
    if (button && !button._originalLabel) button._originalLabel = button.innerHTML;
    var label = button ? button._originalLabel : '';
    if (button) { button.disabled = true; button.classList.add('is-loading'); }

    return fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return readCartResponse(r, ADD_FAIL); })
      .then(refreshCart)
      .then(function () {
        // Stay on the page: the bag count updates and the button confirms.
        var oldMsg = form.querySelector('.form-add-error');
        if (oldMsg) oldMsg.hidden = true;
        var btn = button;
        if (!btn) return;
        btn.disabled = false;
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        btn.textContent = 'Added to cart!';
        clearTimeout(btn._addedTimer);
        btn._addedTimer = setTimeout(function () {
          btn.innerHTML = label;
          btn.classList.remove('is-added');
        }, 2500);
        button = null; // handled; skip the reset below
      })
      .catch(function (err) {
        var msg = form.querySelector('.form-add-error');
        if (!msg) {
          msg = document.createElement('p');
          msg.className = 'form-add-error';
          msg.setAttribute('role', 'alert');
          form.appendChild(msg);
        }
        msg.textContent = messageFor(err, ADD_FAIL);
        clearTimeout(msg._hideTimer);
        msg.hidden = false;
        msg._hideTimer = setTimeout(function () { msg.hidden = true; }, 6000);
      })
      .then(function () {
        if (button) { button.disabled = false; button.classList.remove('is-loading'); button.innerHTML = label; }
      });
  }

  function initCart() {
    drawer = document.getElementById('CartDrawer');

    // Add to cart stays on the page and opens the drawer.
    document.addEventListener('submit', function (e) {
      var form = e.target;
      var action = form.getAttribute('action') || '';
      if (!/\/cart\/add/.test(action) || !window.fetch) return;
      e.preventDefault();
      addToCart(form);
    });

    // Bag icon opens the drawer (the full cart page still works without JavaScript).
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-open-cart]');
      if (!link || !drawer || isCartPage) return;
      e.preventDefault();
      refreshCart().then(openDrawer, openDrawer);
    });

    // Close: × button, clicking the dark backdrop, Continue shopping, or Escape.
    document.addEventListener('click', function (e) {
      if (!drawer || drawer.hidden) return;
      if (e.target.closest('[data-close-cart]') || e.target === drawer) { e.preventDefault(); closeDrawer(); return; }
      var cont = e.target.closest('.cart-drawer .cart-continue, .cart-drawer .cart-empty a');
      if (cont) {
        e.preventDefault();
        closeDrawer();
        var target = document.getElementById('collection');
        if (target) target.scrollIntoView({ behavior: 'smooth' });
        else window.location.href = cont.href;
      }
    });

    document.addEventListener('keydown', function (e) {
      if (!drawer || drawer.hidden) return;
      if (e.key === 'Escape') { closeDrawer(); return; }
      if (e.key !== 'Tab') return;
      var focusable = $$('a[href], button:not([disabled]), input:not([type="hidden"]), [tabindex]:not([tabindex="-1"])', drawer)
        .filter(function (el) { return el.offsetParent !== null; });
      if (!focusable.length) return;
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    // − / + buttons in the drawer and on the cart page.
    document.addEventListener('click', function (e) {
      var step = e.target.closest('[data-cart-step]');
      if (!step) return;
      e.preventDefault();
      var input = step.parentElement.querySelector('[data-cart-key]');
      if (!input) return;
      var qty = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-cart-step'), 10));
      input.value = qty;
      changeLine(input.getAttribute('data-cart-key'), qty, step.closest('form'));
    });

    // Typing a quantity.
    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cart-key]');
      if (!input) return;
      var qty = Math.max(0, parseInt(input.value, 10) || 0);
      changeLine(input.getAttribute('data-cart-key'), qty, input.closest('form'));
    });

    // Remove.
    document.addEventListener('click', function (e) {
      var remove = e.target.closest('[data-cart-remove]');
      if (!remove) return;
      e.preventDefault();
      changeLine(remove.getAttribute('data-cart-remove'), 0, remove.closest('form'));
    });

    // Enter in a quantity box should update, not jump to checkout.
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-cart-key]')) {
        e.preventDefault();
        e.target.blur();
      }
    });

    // Keep the badge right after back/forward navigation.
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) refreshCart();
    });
  }

  /* ---------- Start ---------- */
  function init() {
    setHeaderHeights();
    initMobileMenu();
    initDetailsToggles();
    initExclusiveDetails();
    initGalleries();
    initProductQuantity();
    initContactResult();
    initCart();
    window.addEventListener('resize', setHeaderHeights);
    window.addEventListener('load', setHeaderHeights);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Re-run galleries when sections are edited in the Shopify theme editor.
  document.addEventListener('shopify:section:load', function () { initGalleries(); setHeaderHeights(); });
})();
